import React from "react";

const Customers = () => {
   return(<h1>This is Customers</h1>);
};
export default Customers;